import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Field} from '@app/interfaces';
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-form-input-number',
    templateUrl: './form-input-number.component.html',
    styleUrls: ['./form-input-number.component.scss'],
    standalone: false
})
export class FormInputNumberComponent implements OnInit, OnDestroy {
    @Input() control: AbstractControl;

    @Input() field: Field<number>;

    private destroy$ = new Subject<void>();

    constructor(private cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.control.statusChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.cdr.detectChanges();
            });


        if (!this.control.value && this.field.config.default) {
            this.control.setValue(this.field.config.default);
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
    }
}
